import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageHeader";
import { Avatar, RoleBadge } from "@/components/Brand";
import { Trophy } from "lucide-react";
import { cn } from "@/lib/utils";

export default function Leaderboard() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [segment, setSegment] = useState("all");
  const isAdmin = ["super_admin", "trainer"].includes(user.role);

  useEffect(() => {
    api.get("/leaderboard", { params: { segment } }).then(({ data }) => setRows(data));
  }, [segment]);

  const segments = isAdmin
    ? [["all", "Everyone"], ["internal", "Internal"], ["partner", "Partners"]]
    : [["all", "Everyone"]];

  const medal = ["#F5C044", "#C0C7D0", "#CD8B5B"];

  return (
    <div className="fade-in">
      <PageHeader title="Leaderboard" subtitle="Points from learning and contribution." />

      {isAdmin && (
        <div className="mb-6 inline-flex rounded-lg border border-border bg-card p-1">
          {segments.map(([val, label]) => (
            <button
              key={val}
              onClick={() => setSegment(val)}
              data-testid={`leaderboard-segment-${val}`}
              className={cn("rounded-md px-3.5 py-1.5 text-sm font-medium transition-colors",
                segment === val ? "bg-[#33B6E4] text-white" : "text-muted-foreground hover:text-foreground")}
            >
              {label}
            </button>
          ))}
        </div>
      )}

      <div className="card-surface divide-y divide-border overflow-hidden" data-testid="leaderboard-list">
        {rows.map((r, i) => (
          <div key={r.id} className="flex items-center gap-3 px-4 py-3.5 sm:gap-4 sm:px-5">
            <div
              className="grid h-8 w-8 shrink-0 place-items-center rounded-full text-sm font-bold tnum"
              style={i < 3 ? { background: medal[i], color: "#0D0F12" } : { background: "hsl(var(--secondary))", color: "hsl(var(--muted-foreground))" }}
            >
              {i < 3 ? <Trophy className="h-4 w-4" /> : i + 1}
            </div>
            <Avatar src={r.photo_url} name={r.name} size={38} className="hidden sm:grid" />
            <div className="min-w-0 flex-1">
              <div className="truncate font-medium">{r.name}</div>
              <div className="truncate text-sm text-muted-foreground">{r.company}</div>
              <div className="mt-1 sm:hidden"><RoleBadge role={r.role} /></div>
            </div>
            <div className="hidden sm:block"><RoleBadge role={r.role} /></div>
            <div className="tnum w-14 shrink-0 text-right font-heading text-[16px] font-semibold text-[#1779AC] dark:text-[#5cc7ef] sm:w-20">
              {r.points}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
